<div class="site admin">
  <header class="header shadow sticky-top">

    <div class="menu">

      <div class="container-fluid">

        <div class="">

          <app-admin-menu-header></app-admin-menu-header>

        </div>

      </div>

    </div>

  </header>

  <main class="main container-fluid">

    <div class="row">

      <div class="col-12 col-sm-2 sidebar sidebar-left pt-3 top-0 position-sticky align-self-start">

        <app-admin-side-navigation></app-admin-side-navigation>

      </div>

      <div class="col-12 col-sm-10 main" style="min-width: 0;">

        <router-outlet></router-outlet>

      </div>

    </div>

  </main>

  <footer class="footer admin-footer bg-light pt-4 pb-4">

    <div class="container-fluid">
      &copy; Meet the Youngsters | Beheer
    </div>

  </footer>

</div>
